import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

// 2026-09-27 · Vista on-screen del arqueo por rango. Consume el
// endpoint `GET /data/arqueoLive?start=&end=&top=` que devuelve el
// mismo cálculo que hoy materializa el PDF, pero como DTO tipado.
//
// Sin polling — la vista solo refetch cuando el user cambia rango
// o pulsa "Refrescar". Los datos ya-cargados se conservan en
// `data` durante refetches para no parpadear la UI.

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  // Rango solicitado por última vez (para saber si un refetch
  // debe blanquear la UI o mantenerla como stale-while-revalidate).
  lastRange: null,
};

const slice = createSlice({
  name: "arqueoLive",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    setData(state, action) {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    setLastRange(state, action) {
      state.lastRange = action.payload;
    },
    reset(state) {
      state.data = null;
      state.error = null;
      state.isLoading = false;
      state.lastRange = null;
    },
  },
});

export default slice.reducer;

export const { startLoading, setData, setError, setLastRange, reset } =
  slice.actions;

// Serializa Date a `YYYY-MM-DDTHH:mm:ss` LOCAL (sin `Z`) — el backend
// interpreta como hora del servidor. Igual que hace `createExport`.
function toLocalIso(d) {
  if (typeof d === "string") return d;
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}

export function fetchArqueoLive({ start, end, includeTop = false }) {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(setLastRange({ start, end }));
    try {
      const r = await axios.get("/data/arqueoLive", {
        params: {
          start: toLocalIso(start),
          end: toLocalIso(end),
          top: includeTop,
        },
      });
      dispatch(setData(r.data));
      return r.data;
    } catch (e) {
      dispatch(setError(e?.response?.data?.message || e?.message || "error"));
      throw e;
    }
  };
}
